import { VImg } from 'vuetify/lib/components/VImg';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VImg,{attrs:{"src":require(("@/assets/cards/" + _vm.type + ".svg")),"aria-label":_vm.type,"alt":_vm.type}})}
var staticRenderFns = []

export { render, staticRenderFns }